import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {

  constructor(
    private environment: EnvironmentConfiguration
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let clonedReq = req.clone();

    if (req.method === 'GET' && this.shouldBeIntercepted(req.url)) {
      clonedReq = req.clone({
        headers: this.addNoCacheHeaders(req.headers),
      });
    }

    return next.handle(clonedReq);
  }

  private shouldBeIntercepted(url: string): boolean {
    return url.indexOf(this.environment.baseUrl) !== -1;
  }

  private addNoCacheHeaders(headers: HttpHeaders): HttpHeaders {
    headers = headers.append('Cache-Control', 'no-cache');
    headers = headers.append('Pragma', 'no-cache');
    return headers;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/interceptors/cache.interceptor.ts